export enum CompSkin {
  StripContainerDefaultStripContainer = 'wysiwyg.viewer.skins.stripContainer.DefaultStripContainer',
  WRichTextThemeSkin = 'wysiwyg.viewer.skins.WRichTextThemeSkin',
}
